import { render, staticRenderFns } from "./system_config.vue?vue&type=template&id=bf43c784&scoped=true&"
import script from "./system_config.vue?vue&type=script&lang=js&"
export * from "./system_config.vue?vue&type=script&lang=js&"
import style0 from "./system_config.vue?vue&type=style&index=0&id=bf43c784&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf43c784",
  null
  
)

export default component.exports